import { render, staticRenderFns } from "./sumarios.vue?vue&type=template&id=5841dbde"
import script from "./sumarios.vue?vue&type=script&lang=js"
export * from "./sumarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports